export default "<h3>About</h3>\n<p>This is a TodoList app built using Angular and Chota.css</p>"